<template>
  <v-dialog
    class="base-table"
    v-bind="$attrs"
  >
    <template
      v-for="(_, slot) of slotsList"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="{on: isV2 ? scope.on : [], attrs: isV2 ? scope.attrs : scope.props, props: isV2 ? scope.attrs : scope.props, ...scope}"
      />
    </template>
  </v-dialog>
</template>

<script lang="ts">
import {
  version,
  defineComponent,
} from 'vue';

export default defineComponent({
  name: 'VDialogAdapted',
  computed: {
    isV2() {
      return version[0] === '2';
    },
    slotsList(): any {
      // @ts-ignore
      return version[0] === '2' ? this.$scopedSlots : this.$slots;
    },
  },
});
</script>
